import { BrandMark } from "./ui/Brand";

/**
 * Shown while a day or year is being calculated: the sun slowly rising behind a
 * ridge, which is exactly what the engine is working out.
 */
export default function CalculatingScreen({ label }: { label?: string }) {
	return (
		<div className="flex min-h-dvh flex-col bg-canvas">
			<div className="flex h-13 items-center border-b border-line px-4 text-ink sm:px-6">
				<BrandMark />
			</div>
			<div className="flex flex-1 flex-col items-center justify-center px-6 pb-16 text-center">
				<svg viewBox="0 0 160 72" className="w-40 text-ink" aria-hidden="true">
					<defs>
						<clipPath id="calc-sky">
							<rect x="0" y="0" width="160" height="62" />
						</clipPath>
					</defs>
					<g clipPath="url(#calc-sky)">
						<circle cx="92" cy="44" r="13" fill="var(--c-sun)" className="calc-sun" />
					</g>
					<path
						d="M0 64 L28 40 L44 52 L66 30 L88 48 L104 38 L126 56 L144 46 L160 58 L160 72 L0 72 Z"
						fill="currentColor"
					/>
				</svg>
				<h1 className="mt-6 text-xl font-bold tracking-[-0.02em] text-ink">{label ?? "Beregner soltider …"}</h1>
				<p className="mt-1 max-w-[34ch] text-[15px] text-muted">
					Vi leser terrenget rundt deg og finner når sola kommer over fjellkanten.
				</p>
			</div>
			<style>{`
        @keyframes calc-rise {
          0% { transform: translateY(26px); }
          60%, 100% { transform: translateY(-6px); }
        }
        .calc-sun { animation: calc-rise 2.4s cubic-bezier(.3,.6,.3,1) infinite alternate; }
      `}</style>
		</div>
	);
}
